import React from "react"

import IntroSection from "../components/IntroSection";
import SolutionsSection from "../components/SolutionsSection";
import BlueSectionDivider from "../components/BlueSectionDivider";
import DAComponents  from "../components/DAComponents";
import DABenefits from "../components/DABenefits";
import CountriesSection from "../components/CountriesSection";
import ReimagineSection from "../components/ReimagineSection";
import ProjectsSection from "../components/ProjectsSection";
import TeamSection from "../components/TeamSection";
import WhyUsSection from "../components/WhyUsSection";
import TechStackSection from "../components/TechStackSection";
import DAFaq from "../components/DAFaq";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const DigitalAcceleration = () => {
    return (
        <div>
            <IntroSection title = "DIGITAL ACCELERATION" paragraph="Own the change, accelerate your growth, and innovate with confidence." backgroundImage="/images/da-bg.webp"/>
            <SolutionsSection para1="Our digital acceleration expertise covers an array of areas, from simpler projects such as web app building to highly complex ML & AI integration." para2="Imaginary Cloud’s digital acceleration services empower your organization to swiftly embrace digital acceleration and achieve remarkable growth. Our comprehensive approach combines cutting-edge technologies, agile methodologies, and user-centric design to deliver tangible results that propel your business forward."/>
            <BlueSectionDivider/>
            <DAComponents/>
            <BlueSectionDivider/>
            <DABenefits/>
            <BlueSectionDivider/>
            <CountriesSection/>
            <BlueSectionDivider/>
            <ReimagineSection/>
            <BlueSectionDivider/>
            <ProjectsSection/>
            <BlueSectionDivider/>
            <TeamSection/>
            <WhyUsSection/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <DAFaq/>
            <BlueSectionDivider/>
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>

        </div>
    )
}
export default DigitalAcceleration;